import React, { useState, useEffect, useCallback, useRef, memo, useMemo } from 'react';
import "./MentorsPage.css";
import { useAuth } from '../auth/Auth';
import HelpRequestsColumnComponent from './HelpRequestsColumn';

const userNamesMap = {
 '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
 '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
 '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
 '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим.',
 '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
 '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
 'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
 '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
 '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
 '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
 'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',
 '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
 '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
 '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
 '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
 'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
 'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
 '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
 '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
 '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
 '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
 '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
 '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
 'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
 '76': 'Сачовська Діана',
 '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
 '77': 'Дудар Максим',
 '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
 '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
 '78': 'Мелих Владислав',
 '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
 'Chat Manager Syrve POS Support': 'Chat Manager Syrve POS Support',
 '43481fb68ba4c410a7413a331ae63e2d': 'Шершньов Микита',
 'd9bc61c8d39e7373c61e61a04073b9a8': 'Гіщинський Любомир',
 'XCr0s5X': '4fee0b2cd341f9ca21a174006703164d',
 'Nikita': '43481fb68ba4c410a7413a331ae63e2d',
 '4fee0b2cd341f9ca21a174006703164d': 'Лебідь Роман',
 '84': 'Лебідь Роман',
 'bfd39278cf8337ccbf4eb10878d229da': 'Даниленко Денис',
 '74fa21afdcce740f82d72c5f3b6b5d55': 'Шульська Аліна',
 'dc58ddc1c7a369bcf15936d93ed911d3': 'Роман Ірина',
 'b843e12a0cb74f150b46ce4869da2ba4': 'Клепацький Дмитро',
 '21a3c2811d3a9d5e80ae58ed2dee08af': 'Когут Марія',
 'a4512bf2acb5c96a3254c819f0a358d4': 'Морозюк Роман',
 '3b17ccb07571b6c02427fa6ebe584dc7': 'Мазурян Евеліна',
 'a707c5bab2d536a1df71095e588534b7': 'Нестерович Євгеній',
 '25009328c12e7616e397462b3ac403a7': 'Колбінов Валентин',
 '7ba3395596ec209f829d5f4b846d6cd7': 'Керніцька Христина',
 '725301d7478b0bf2e0db9c1c8c2c1234': 'Запольська Єлизавета',
 '2fc4fe00de48cd6b723a21cd17e562fc': 'Смирнова Кристина',
};

const getUserName = (userId) => {
 if (!userId) return 'Невідомий';
 return userNamesMap[userId] || userNamesMap[String(userId)] || userId;
};

const getUserNameFromTaskData = (taskData) => {
 if (!taskData) return 'Невідомий';

 if (taskData.User?.length > 0) {
 const name = getUserName(taskData.User[0]);
 if (name !== taskData.User[0]) return name;
 }

 if (taskData.userId) {
 const name = getUserName(taskData.userId);
 if (name !== taskData.userId) return name;
 }

 if (taskData.who) {
 const name = getUserName(taskData.who);
 if (name !== taskData.who) return name;
 }

 return taskData.userName || 'Невідомий користувач';
};

// Оптимізований компонент таймера
const Timer = memo(({ receivedAt }) => {
 const [timeText, setTimeText] = useState('0:00');

 useEffect(() => {
 if (!receivedAt) return;

 let animationFrameId;
 let lastUpdate = 0;

 const updateTimer = (now) => {
 const startTime = new Date(receivedAt);
 const diffMs = now - startTime;

 if (diffMs < 0) {
 setTimeText('0:00');
 return;
 }

 const totalSeconds = Math.floor(diffMs / 1000);
 const hours = Math.floor(totalSeconds / 3600);
 const minutes = Math.floor((totalSeconds % 3600) / 60);
 const seconds = totalSeconds % 60;

 if (hours > 0) {
 setTimeText(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
 } else {
 setTimeText(`${minutes}:${seconds.toString().padStart(2, '0')}`);
 }
 };

 const tick = (timestamp) => {
 if (!lastUpdate || timestamp - lastUpdate >= 1000) {
 updateTimer(new Date());
 lastUpdate = timestamp;
 }
 animationFrameId = requestAnimationFrame(tick);
 };

 animationFrameId = requestAnimationFrame(tick);
 return () => {
 if (animationFrameId) {
 cancelAnimationFrame(animationFrameId);
 }
 };
 }, [receivedAt]);

 return <span> {timeText}</span>;
});

// Оптимізований компонент запиту на допомогу
const HelpRequestItem = memo(({ request, onTakeHelp }) => {
 const userName = useMemo(() => getUserNameFromTaskData(request), [request]);
 const taskStatus = request.TaskStatus || request.taskStatus || '';
 const isInProgress = taskStatus === 'В роботі' || taskStatus === 'В работе' || taskStatus === 'In progress';

 const handleTakeClick = useCallback((e) => {
 e.stopPropagation();
 onTakeHelp(request);
 }, [request, onTakeHelp]);

 return (
 <div className="help-request-card">
 <div className="help-request-info">
 <div className="help-request-user"> {userName}</div>
 <div className="help-request-task"> {request.TaskName || request.taskName || 'Без назви'}</div>
 {request.projectName && <div className="help-request-project"> {request.projectName}</div>}
 <div className="help-request-status">
 <span className={`status-badge ${isInProgress ? 'status-in-progress' : 'status-in-queue'}`}>
 {isInProgress ? 'В роботі' : 'В черзі'}
 </span>
 </div>
 <Timer receivedAt={request.receivedAt} />
 </div>
 <button className="help-request-take-btn" onClick={handleTakeClick}>Займаюся</button>
 </div>
 );
});

// Оптимізований компонент відповіді
const AnsweredRequestItem = memo(({ answer }) => {
 const taskData = answer.taskData;
 const taskStatus = taskData?.TaskStatus || taskData?.taskStatus || '';
 const activeStatuses = useMemo(() => ['В роботі', 'В работе', 'In progress', 'В черзі', 'В очереди'], []);

 if (!activeStatuses.includes(taskStatus)) return null;

 const userName = useMemo(() => getUserNameFromTaskData(taskData), [taskData]);
 const mentorName = useMemo(() => getUserName(answer.mentorId), [answer.mentorId]);
 const answerText = answer.answerType === 'now' ? 'Зараз' : `Через ${answer.minutes} хв`;

 return (
 <div className="answered-request-card">
 <div className="answered-request-info">
 <div className="answered-request-user"> {userName}</div>
 <div className="answered-request-task"> {taskData?.TaskName || taskData?.taskName || 'Без назви'}</div>
 <div className="answered-request-mentor"> Ментор: {mentorName}</div>
 <div className="answered-request-answer"> {answerText}</div>
 {answer.answerType === 'later' && (
 <CountdownTimer answeredAt={answer.answeredAt} minutes={answer.minutes} />
 )}
 {answer.answerType === 'now' && (
 <div className="answered-request-status"> В роботі</div>
 )}
 </div>
 <a
 href={taskData?.TaskLink || taskData?.taskLink}
 target="_blank"
 rel="noopener noreferrer"
 className="answered-request-link"
 onClick={(e) => e.stopPropagation()}
 >
 →
 </a>
 </div>
 );
});

// Компонент зворотнього відліку
const CountdownTimer = memo(({ answeredAt, minutes }) => {
 const [timeLeftText, setTimeLeftText] = useState('');

 useEffect(() => {
 if (!minutes || minutes <= 0) return;

 let animationFrameId;
 let lastUpdate = 0;

 const updateTimer = () => {
 const answeredDateTime = new Date(answeredAt);
 const targetTime = new Date(answeredDateTime.getTime() + minutes * 60000);
 const now = new Date();
 const remainingMs = targetTime - now;

 if (remainingMs > 0) {
 const remainingMinutes = Math.floor(remainingMs / 60000);
 const remainingSeconds = Math.floor((remainingMs % 60000) / 1000);
 setTimeLeftText(`${remainingMinutes}:${remainingSeconds.toString().padStart(2, '0')}`);
 } else {
 setTimeLeftText('Час вийшов!');
 }
 };

 const tick = (timestamp) => {
 if (!lastUpdate || timestamp - lastUpdate >= 1000) {
 updateTimer();
 lastUpdate = timestamp;
 }
 animationFrameId = requestAnimationFrame(tick);
 };

 animationFrameId = requestAnimationFrame(tick);
 return () => {
 if (animationFrameId) {
 cancelAnimationFrame(animationFrameId);
 }
 };
 }, [answeredAt, minutes]);

 if (!timeLeftText) return null;

 return (
 <div className={`answered-request-timer ${timeLeftText === 'Час вийшов!' ? 'expired' : ''}`}>
 Залишилось: {timeLeftText}
 </div>
 );
});

// Модальне вікно
const AnswerModal = memo(({ isOpen, selectedTask, answerType, answerMinutes, onAnswerTypeChange, onMinutesChange, onSubmit, onClose }) => {
 if (!isOpen || !selectedTask) return null;

 const handleOverlayClick = useCallback((e) => {
 if (e.target === e.currentTarget) onClose();
 }, [onClose]);

 const userName = useMemo(() => getUserNameFromTaskData(selectedTask), [selectedTask]);

 return (
 <div className="modal-overlay" onClick={handleOverlayClick}>
 <div className="modal-content">
 <div className="modal-header">
 <h3>Відповідь на запит допомоги</h3>
 <button className="modal-close" onClick={onClose}>×</button>
 </div>
 <div className="modal-body">
 <div className="modal-task-info">
 <div><strong>Користувач:</strong> {userName}</div>
 <div><strong>Задача:</strong> {selectedTask.TaskName || selectedTask.taskName || 'Без назви'}</div>
 </div>

 <div className="modal-options">
 <label className="modal-option">
 <input
 type="radio"
 name="answerType"
 value="now"
 checked={answerType === 'now'}
 onChange={() => onAnswerTypeChange('now')}
 />
 <span>Займаюся зараз</span>
 </label>

 <label className="modal-option">
 <input
 type="radio"
 name="answerType"
 value="later"
 checked={answerType === 'later'}
 onChange={() => onAnswerTypeChange('later')}
 />
 <span>Займуся через</span>
 {answerType === 'later' && (
 <>
 <input
 type="number"
 className="minutes-input"
 placeholder="хвилин"
 value={answerMinutes}
 onChange={(e) => onMinutesChange(e.target.value)}
 min="1"
 max="120"
 />
 <span>хв</span>
 </>
 )}
 </label>
 </div>
 </div>
 <div className="modal-footer">
 <button className="modal-cancel" onClick={onClose}>Скасувати</button>
 <button className="modal-submit" onClick={onSubmit}>Підтвердити</button>
 </div>
 </div>
 </div>
 );
});

// Компонент картки задачі
const TaskCard = memo(({ task, isAllTasksColumn = false, taskTimers }) => {
 const taskLink = task.TaskLink || task.taskLink;
 const taskName = task.TaskName || task.taskName || 'Без назви';
 const projectName = task.ProjectName || task.projectName || '';
 const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове';

 const timeData = taskTimers[taskLink];
 if (!timeData) return null;

 const minutes = timeData.totalMinutes;
 let progressColor = '#4caf50';
 if (minutes >= 5 && minutes < 30) {
 progressColor = '#ff9800';
 } else if (minutes >= 30 && minutes < 360) {
 progressColor = '#f44336';
 }

 const handleTaskClick = useCallback(() => {
 window.open(taskLink, '_blank');
 }, [taskLink]);

 let cardClass = `mentor-task-card ${isBlocker ? 'blocker' : ''}`;
 let statusBadge = null;

 if (isAllTasksColumn) {
 if (task.hasMentor) {
 cardClass += ' has-mentor';
 statusBadge = <div className="task-status-badge mentor-badge"> Є ментор: {task.mentorName}</div>;
 } else if (task.isKpiHidden) {
 cardClass += ' kpi-hidden';
 statusBadge = <div className="task-status-badge kpi-badge"> Задача знята з KPI</div>;
 }
 }

 return (
 <div className={cardClass} onClick={handleTaskClick} style={{ cursor: 'pointer' }}>
 <div
 className="task-progress-bar"
 style={{
 width: `${Math.min(100, (minutes / 360) * 100)}%`,
 backgroundColor: progressColor
 }}
 />
 <div className="task-content">
 <div className="task-header">
 <span className="user-name">{task.userIcon} {task.userName}</span>
 <span className="start-time">{task.startTime}</span>
 </div>
 <div className="task-name" title={taskName}>{taskName}</div>
 {projectName && <div className="task-project" title={projectName}>{projectName}</div>}
 {statusBadge}
 <div className="task-timer">{timeData.text}</div>
 <div className="task-link-arrow">→</div>
 </div>
 </div>
 );
});

// Компонент колонки задач
const TasksColumn = memo(({ title, visibleTasks, hiddenTasks, color, isCollapsed, onToggleCollapse, showHidden = true, isAllTasksColumn = false, taskTimers }) => {
 const visibleTasksMemo = useMemo(() => visibleTasks, [visibleTasks]);
 const hiddenTasksMemo = useMemo(() => hiddenTasks, [hiddenTasks]);

 return (
 <div className="mentor-tasks-column">
 <div className="column-header" style={{ backgroundColor: color }}>
 <h3>{title}</h3>
 <span className="tasks-count">{visibleTasks.length + hiddenTasks.length}</span>
 </div>
 <div className="tasks-container">
 {visibleTasksMemo.length > 0 && (
 <div className="visible-tasks">
 {visibleTasksMemo.map(task => (
 <TaskCard key={task.TaskLink || task.taskLink} task={task} isAllTasksColumn={isAllTasksColumn} taskTimers={taskTimers} />
 ))}
 </div>
 )}
 {showHidden && hiddenTasksMemo.length > 0 && (
 <div className="hidden-tasks-section">
 <div className="hidden-tasks-header" onClick={onToggleCollapse}>
 <span className="hidden-tasks-icon">{isCollapsed ? '' : '▼'}</span>
 <span className="hidden-tasks-title">Приховані задачі ({hiddenTasks.length})</span>
 </div>
 {!isCollapsed && (
 <div className="hidden-tasks-list">
 {hiddenTasksMemo.map(task => (
 <TaskCard key={task.TaskLink || task.taskLink} task={task} isAllTasksColumn={isAllTasksColumn} taskTimers={taskTimers} />
 ))}
 </div>
 )}
 </div>
 )}
 {visibleTasks.length === 0 && hiddenTasks.length === 0 && (
 <div className="no-tasks-message">Немає задач</div>
 )}
 </div>
 </div>
 );
});

function MentorsPage() {
 const { user } = useAuth();
 const [webhooks, setWebhooks] = useState([]);
 const [dutyData, setDutyData] = useState([]);
 const [noHelpTasks, setNoHelpTasks] = useState([]);
 const [kpiTasks, setKpiTasks] = useState([]);
 const [mentorTasks, setMentorTasks] = useState([]);
 const [archivedTasks, setArchivedTasks] = useState([]);
 const [askHelpTasks, setAskHelpTasks] = useState([]);
 const [answerAskHelpTasks, setAnswerAskHelpTasks] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState('');
 const [showAllTasks, setShowAllTasks] = useState(false);
 const [currentTime, setCurrentTime] = useState(new Date());
 const [theme, setTheme] = useState('white');

 const [collapsedFirstHidden, setCollapsedFirstHidden] = useState(true);
 const [collapsedSecondHidden, setCollapsedSecondHidden] = useState(true);
 const [collapsedOtherTasks, setCollapsedOtherTasks] = useState(false);
 const [collapsedStatuses, setCollapsedStatuses] = useState({});
 const [collapsedUsers, setCollapsedUsers] = useState({});

 const [modalState, setModalState] = useState({
 isOpen: false,
 selectedTask: null,
 answerType: 'now',
 answerMinutes: ''
 });

 const [taskTimers, setTaskTimers] = useState({});
 const userId = user?.user_id || localStorage.getItem('userId') || '271';

 // Мемоізовані значення
 const activeStatuses = useMemo(() => [
 { key: 'Черговому', label: 'Черговому' },
 { key: 'Дежурному', label: 'Дежурному' },
 { key: 'В роботі', label: 'В роботі' },
 { key: 'В работе', label: 'В роботі' },
 { key: 'In progress', label: 'В роботі' },
 { key: 'В черзі', label: 'В черзі' },
 { key: 'В очереди', label: 'В черзі' },
 { key: 'В черзі (м\'яч не у нас)', label: 'В черзі (м\'яч не у нас)' },
 { key: 'В очереди (мяч не у нас)', label: 'В черзі (м\'яч не у нас)' }
 ], []);

 // Функції з useCallback
 const shouldExcludeTask = useCallback((taskName) => {
 if (!taskName) return false;
 const lowerCaseName = taskName.toLowerCase();

 if (lowerCaseName.includes('заявка №')) return true;

 const obidVariants = ['обід', 'обед', 'обiд', 'обїд', 'oбід', 'oбед', 'oбiд', 'oбїд', 'обеда', 'обіда', 'ланч', 'ланча', 'lunch'];
 return obidVariants.some(variant => lowerCaseName.includes(variant));
 }, []);

 const isTaskArchived = useCallback((taskLink) => {
 if (!archivedTasks || !Array.isArray(archivedTasks)) return false;
 return archivedTasks.some(archivedTask => {
 const archivedTaskLink = archivedTask.TaskLink || archivedTask.taskLink;
 return archivedTaskLink === taskLink;
 });
 }, [archivedTasks]);

 const getLatestMentor = useCallback((taskLink) => {
 const taskMentorEntries = mentorTasks.filter(task => {
 const taskLinkMatch = (task.TaskLink || task.taskLink) === taskLink;
 return taskLinkMatch;
 });

 if (taskMentorEntries.length === 0) return null;

 const sortedEntries = [...taskMentorEntries].sort((a, b) =>
 new Date(b.receivedAt) - new Date(a.receivedAt)
 );

 return sortedEntries[0].Mentor || sortedEntries[0].mentor || '';
 }, [mentorTasks]);

 const hasMentor = useCallback((taskLink) => {
 const mentor = getLatestMentor(taskLink);
 return mentor && mentor.trim() !== '';
 }, [getLatestMentor]);

 const isKpiHidden = useCallback((taskLink) => {
 const taskKpiEntries = kpiTasks.filter(task => {
 const taskLinkMatch = (task.TaskLink || task.taskLink) === taskLink;
 return taskLinkMatch;
 });

 if (taskKpiEntries.length === 0) return false;

 const sortedEntries = [...taskKpiEntries].sort((a, b) =>
 new Date(b.receivedAt) - new Date(a.receivedAt)
 );

 return sortedEntries[0].hide === 'Yes';
 }, [kpiTasks]);

 const calculateTimeInProgress = useCallback((receivedAt) => {
 if (!receivedAt) return null;

 const startTime = new Date(receivedAt);
 const now = currentTime;
 const timeInMs = now - startTime;

 if (timeInMs < 0) {
 return { hours: 0, minutes: 0, seconds: 0, totalMinutes: 0, text: '0:00', timeInMs: 0 };
 }

 const totalSeconds = Math.floor(timeInMs / 1000);
 const hours = Math.floor(totalSeconds / 3600);
 const minutes = Math.floor((totalSeconds % 3600) / 60);
 const seconds = totalSeconds % 60;

 return {
 hours, minutes, seconds,
 totalMinutes: Math.floor(timeInMs / (1000 * 60)),
 text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
 timeInMs
 };
 }, [currentTime]);

 const formatStartTime = useCallback((receivedAt) => {
 if (!receivedAt) return '';
 const date = new Date(receivedAt);
 return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
 }, []);

 const getAllActiveUsers = useCallback(() => {
 if (!dutyData || !Array.isArray(dutyData)) return [];

 const latestActions = {};
 dutyData.forEach(entry => {
 const userId = entry.who;
 const action = entry.action;
 const receivedAt = new Date(entry.receivedAt);

 if (!latestActions[userId] || receivedAt > new Date(latestActions[userId].receivedAt)) {
 latestActions[userId] = { action, receivedAt: entry.receivedAt };
 }
 });

 return Object.keys(latestActions).filter(userId => latestActions[userId].action.includes('_yes'));
 }, [dutyData]);

 const getUserMainRole = useCallback((userId) => {
 if (!dutyData || !Array.isArray(dutyData)) return null;

 const userEntries = dutyData
 .filter(entry => entry.who === userId)
 .sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));

 if (userEntries.length === 0) return null;

 const action = userEntries[0].action;
 if (action === 'duty_task_yes') return 'duty_task_yes';
 if (action === 'duty_chat_yes') return 'duty_chat_yes';
 if (action === 'mentor_yes') return 'mentor_yes';
 if (action === 'coordinator_yes') return 'coordinator_yes';
 if (action === 'teamlead_yes') return 'teamlead_yes';

 return null;
 }, [dutyData]);

 const getUserTasksInProgress = useCallback((userId) => {
 if (!webhooks || !Array.isArray(webhooks)) return [];

 return webhooks.filter(webhook => {
 const users = webhook.User || [];
 const taskStatus = webhook.TaskStatus || webhook.taskStatus || '';
 const implementerTask = webhook.implementer_task || webhook.ImplementerTask || '';
 const isNotImplementerTask = implementerTask !== 'Yes' && implementerTask !== 'Так';
 const taskName = webhook.TaskName || webhook.taskName || '';
 const taskLink = webhook.TaskLink || webhook.taskLink;

 const belongsToUser = users.includes(userId);
 const isInProgress = taskStatus === 'В роботі' || taskStatus === 'В работе' || taskStatus === 'In progress';
 const isNotDutyTask = !taskName.toLowerCase().includes('чергування') && !taskName.toLowerCase().includes('дежурство');
 const isExcludedTask = shouldExcludeTask(taskName);
 const isArchived = isTaskArchived(taskLink);

 return belongsToUser && isInProgress && isNotImplementerTask && isNotDutyTask && !isExcludedTask && !isArchived;
 });
 }, [webhooks, shouldExcludeTask, isTaskArchived]);

 const getUsersWithTasks = useCallback(() => {
 const activeUsers = getAllActiveUsers();
 const usersWithTasks = {};

 activeUsers.forEach(userId => {
 const tasks = getUserTasksInProgress(userId);
 if (tasks.length > 0) {
 const userName = getUserName(userId);
 const mainRole = getUserMainRole(userId);

 usersWithTasks[userId] = {
 id: userId,
 name: userName,
 mainRole: mainRole,
 roleIcon: mainRole ? { 'duty_task_yes': '', 'duty_chat_yes': '', 'mentor_yes': '', 'coordinator_yes': '', 'teamlead_yes': '' }[mainRole] : '',
 tasks: tasks.map(task => ({
 ...task,
 timeInProgress: calculateTimeInProgress(task.receivedAt),
 startTime: formatStartTime(task.receivedAt),
 hasMentor: hasMentor(task.TaskLink || task.taskLink),
 isKpiHidden: isKpiHidden(task.TaskLink || task.taskLink),
 mentorName: getLatestMentor(task.TaskLink || task.taskLink)
 }))
 };
 }
 });

 return usersWithTasks;
 }, [getAllActiveUsers, getUserTasksInProgress, getUserMainRole, calculateTimeInProgress, formatStartTime, hasMentor, isKpiHidden, getLatestMentor]);

 const getTasksForReminders = useCallback(() => {
 const usersWithTasks = getUsersWithTasks();
 const allTasks = [];

 Object.values(usersWithTasks).forEach(user => {
 user.tasks.forEach(task => {
 const taskName = task.TaskName || task.taskName || '';

 if (!shouldExcludeTask(taskName) && !task.hasMentor && !task.isKpiHidden) {
 allTasks.push({
 ...task,
 userId: user.id,
 userName: user.name,
 userRole: user.mainRole,
 userIcon: user.roleIcon
 });
 }
 });
 });

 return allTasks.sort((a, b) => b.timeInProgress.timeInMs - a.timeInProgress.timeInMs);
 }, [getUsersWithTasks, shouldExcludeTask]);

 const getAllTasksForDisplay = useCallback(() => {
 const usersWithTasks = getUsersWithTasks();
 const allTasks = [];

 Object.values(usersWithTasks).forEach(user => {
 user.tasks.forEach(task => {
 const taskName = task.TaskName || task.taskName || '';
 if (!shouldExcludeTask(taskName)) {
 allTasks.push({
 ...task,
 userId: user.id,
 userName: user.name,
 userRole: user.mainRole,
 userIcon: user.roleIcon
 });
 }
 });
 });

 return allTasks.sort((a, b) => b.timeInProgress.timeInMs - a.timeInProgress.timeInMs);
 }, [getUsersWithTasks, shouldExcludeTask]);

 const getTasksByTimeRanges = useCallback((tasks) => {
 const result = {
 firstVisible: [],
 firstHidden: [],
 secondVisible: [],
 secondHidden: [],
 otherTasks: []
 };

 tasks.forEach(task => {
 const minutes = task.timeInProgress.totalMinutes;
 const MAX_SECOND_COLUMN_MINUTES = 360;

 if (minutes >= 5 && minutes < MAX_SECOND_COLUMN_MINUTES) {
 if (minutes < 55) {
 if (minutes >= 15) {
 result.firstVisible.push(task);
 } else {
 result.firstHidden.push(task);
 }
 }
 if (minutes >= 45) {
 result.secondVisible.push(task);
 } else if (minutes >= 30) {
 result.secondHidden.push(task);
 }
 } else if (minutes < 5) {
 result.otherTasks.push(task);
 }
 });

 return result;
 }, []);

 const isTaskActive = useCallback((taskData) => {
 if (!taskData) return false;

 const taskStatus = taskData.TaskStatus || taskData.taskStatus || '';
 const taskLink = taskData.TaskLink || taskData.taskLink;

 const activeStatusesList = ['В роботі', 'В работе', 'In progress', 'В черзі', 'В очереди'];
 const isActiveStatus = activeStatusesList.includes(taskStatus);
 const isNotArchived = !isTaskArchived(taskLink);

 return isActiveStatus && isNotArchived;
 }, [isTaskArchived]);

 const getActiveAskHelpTasks = useCallback(() => {
 if (!askHelpTasks || !Array.isArray(askHelpTasks)) return [];

 const answeredSessionIds = answerAskHelpTasks.map(answer => answer.taskData?.sessionId);

 return askHelpTasks.filter(task => {
 const isNotAnswered = !answeredSessionIds.includes(task.sessionId);
 if (!isNotAnswered) return false;
 return isTaskActive(task);
 });
 }, [askHelpTasks, answerAskHelpTasks, isTaskActive]);

 const getActiveAnsweredRequests = useCallback(() => {
 if (!answerAskHelpTasks || !Array.isArray(answerAskHelpTasks)) return [];

 return answerAskHelpTasks.filter(answer => {
 const taskData = answer.taskData;
 if (!taskData) return false;
 return isTaskActive(taskData);
 });
 }, [answerAskHelpTasks, isTaskActive]);

 // Функції для роботи з API
 const deleteHelpRequestCompletely = useCallback(async (sessionId) => {
 try {
 console.log(' Повне видалення запиту:', sessionId);

 await fetch(`https://hub2.daolog.net/api/ask-help-task-by-session/${encodeURIComponent(sessionId)}`, {
 method: 'DELETE'
 });

 await fetch(`https://hub2.daolog.net/api/answer-ask-help-task-by-session/${encodeURIComponent(sessionId)}`, {
 method: 'DELETE'
 });

 return true;
 } catch (error) {
 console.error(' Помилка видалення:', error);
 return false;
 }
 }, []);

 const fetchAskHelpTasks = useCallback(async () => {
 try {
 const response = await fetch(`https://hub2.daolog.net/api/ask-help-tasks`);
 if (response.ok) {
 const data = await response.json();
 if (data.success) {
 const filteredAskHelp = (data.askHelpTasks || []).filter(task => {
 const taskStatus = task.TaskStatus || task.taskStatus || '';
 const activeStatusesList = ['В роботі', 'В работе', 'In progress', 'В черзі', 'В очереди'];
 return activeStatusesList.includes(taskStatus);
 });
 setAskHelpTasks(filteredAskHelp);
 }
 }
 } catch (error) {
 console.error('Error fetching ask help tasks:', error);
 }
 }, []);

 const fetchAnswerAskHelpTasks = useCallback(async () => {
 try {
 const response = await fetch(`https://hub2.daolog.net/api/answer-ask-help-tasks`);
 if (response.ok) {
 const data = await response.json();
 if (data.success) {
 setAnswerAskHelpTasks(data.answerAskHelpTasks || []);
 }
 }
 } catch (error) {
 console.error('Error fetching answer ask help tasks:', error);
 }
 }, []);

 const postAnswerAskHelp = useCallback(async (taskData, answerType, minutes) => {
 try {
 const mentorId = userId;
 const mentorNameValue = getUserName(userId);
 const sessionId = taskData.sessionId;

 if (answerType === 'decline') {
 console.log(' Відмова ментора - повне видалення запиту');
 const deleted = await deleteHelpRequestCompletely(sessionId);

 if (deleted) {
 await Promise.all([fetchAskHelpTasks(), fetchAnswerAskHelpTasks()]);
 return true;
 }
 return false;
 }

 const response = await fetch(`https://hub2.daolog.net/api/answer-ask-help-task`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({
 taskData: taskData,
 mentorId: mentorId,
 mentorName: mentorNameValue,
 answerType: answerType,
 minutes: answerType === 'later' ? parseInt(minutes) : 0,
 answeredAt: new Date().toISOString()
 }),
 });

 if (response.ok) {
 const data = await response.json();
 if (data.success) {
 await Promise.all([fetchAskHelpTasks(), fetchAnswerAskHelpTasks()]);
 return true;
 }
 }
 return false;
 } catch (error) {
 console.error('Error posting answer:', error);
 return false;
 }
 }, [userId, deleteHelpRequestCompletely, fetchAskHelpTasks, fetchAnswerAskHelpTasks]);

 // Функції для UI
 const openModal = useCallback((task) => {
 setModalState({
 isOpen: true,
 selectedTask: task,
 answerType: 'now',
 answerMinutes: ''
 });
 }, []);

 const closeModal = useCallback(() => {
 setModalState(prev => ({ ...prev, isOpen: false }));
 }, []);

 const handleAnswerTypeChange = useCallback((type) => {
 setModalState(prev => ({ ...prev, answerType: type }));
 }, []);

 const handleMinutesChange = useCallback((minutes) => {
 setModalState(prev => ({ ...prev, answerMinutes: minutes }));
 }, []);

 const handleSubmitAnswer = useCallback(async () => {
 const { selectedTask, answerType, answerMinutes } = modalState;
 if (!selectedTask) return;

 if (answerType === 'later' && (!answerMinutes || parseInt(answerMinutes) <= 0)) {
 alert('Будь ласка, введіть кількість хвилин');
 return;
 }

 const success = await postAnswerAskHelp(selectedTask, answerType, answerMinutes);
 if (success) {
 closeModal();
 } else {
 alert('Помилка при збереженні відповіді');
 }
 }, [modalState, postAnswerAskHelp, closeModal]);

 const handleDeclineMentor = useCallback(async (answer) => {
 const sessionId = answer.taskData?.sessionId;
 if (!sessionId) return;

 console.log(' Відмова від менторства для:', sessionId);

 const success = await deleteHelpRequestCompletely(sessionId);

 if (success) {
 await Promise.all([fetchAskHelpTasks(), fetchAnswerAskHelpTasks()]);
 alert(' Ви відмовились від менторства. Запит видалено.');
 } else {
 alert(' Помилка при відмові від менторства');
 }
 }, [deleteHelpRequestCompletely, fetchAskHelpTasks, fetchAnswerAskHelpTasks]);

 // Завантаження даних
 useEffect(() => {
 const fetchData = async () => {
 if (!userId) {
 setLoading(false);
 return;
 }

 try {
 setError('');

 const [webhooksResponse, dutyResponse, noHelpResponse, kpiResponse, mentorResponse, archivedResponse] = await Promise.all([
 fetch(`https://hub2.daolog.net/api/all-webhooks`),
 fetch(`https://hub2.daolog.net/api/duty-data`),
 fetch(`https://hub2.daolog.net/api/no-help-tasks`),
 fetch(`https://hub2.daolog.net/api/kpi-tasks`),
 fetch(`https://hub2.daolog.net/api/mentor-tasks`),
 fetch(`https://hub2.daolog.net/api/archived-tasks`)
 ]);

 const webhooksData = await webhooksResponse.json();
 const dutyDataResponse = await dutyResponse.json();

 if (noHelpResponse.ok) {
 const noHelpData = await noHelpResponse.json();
 if (noHelpData.success) setNoHelpTasks(noHelpData.noHelpTasks || []);
 }
 if (kpiResponse.ok) {
 const kpiData = await kpiResponse.json();
 if (kpiData.success) setKpiTasks(kpiData.kpiTasks || []);
 }
 if (mentorResponse.ok) {
 const mentorData = await mentorResponse.json();
 if (mentorData.success) setMentorTasks(mentorData.mentorTasks || []);
 }
 if (archivedResponse.ok) {
 const archivedData = await archivedResponse.json();
 if (archivedData.success) setArchivedTasks(archivedData.archivedTasks || []);
 }

 if (webhooksData.success) setWebhooks(webhooksData.webhooks || []);
 if (dutyDataResponse.success) setDutyData(dutyDataResponse.dutyData || []);

 await Promise.all([fetchAskHelpTasks(), fetchAnswerAskHelpTasks()]);

 } catch (error) {
 console.error('Помилка завантаження даних:', error);
 setError(`Помилка завантаження даних: ${error.message}`);
 } finally {
 setLoading(false);
 }
 };

 fetchData();

 const fetchThemeConfig = async () => {
 try {
 const response = await fetch(`https://hub2.daolog.net/user-theme-config/${userId}`);
 if (response.ok) {
 const config = await response.json();
 setTheme(config.theme || 'white');
 }
 } catch (error) {
 console.error('Error fetching theme config:', error);
 }
 };

 fetchThemeConfig();

 const interval = setInterval(fetchData, 30000);
 return () => clearInterval(interval);
 }, [userId, fetchAskHelpTasks, fetchAnswerAskHelpTasks]);

 // Оновлення часу
 useEffect(() => {
 const interval = setInterval(() => {
 setCurrentTime(new Date());
 }, 1000);
 return () => clearInterval(interval);
 }, []);

 // Оновлення таймерів
 useEffect(() => {
 const updateTimers = () => {
 const allTasks = getTasksForReminders();
 const timers = {};
 allTasks.forEach(task => {
 const taskId = task.TaskLink || task.taskLink;
 timers[taskId] = calculateTimeInProgress(task.receivedAt);
 });
 setTaskTimers(timers);
 };

 updateTimers();
 const interval = setInterval(updateTimers, 1000);
 return () => clearInterval(interval);
 }, [getTasksForReminders, calculateTimeInProgress]);

 // Мемоізовані значення для рендеру
 const reminderTasks = useMemo(() => getTasksForReminders(), [getTasksForReminders]);
 const { firstVisible, firstHidden, secondVisible, secondHidden, otherTasks } = useMemo(() => getTasksByTimeRanges(reminderTasks), [reminderTasks, getTasksByTimeRanges]);
 const allTasksForDisplay = useMemo(() => getAllTasksForDisplay(), [getAllTasksForDisplay]);
 const allTasksByTimeRanges = useMemo(() => getTasksByTimeRanges(allTasksForDisplay), [allTasksForDisplay, getTasksByTimeRanges]);
 const usersWithTasks = useMemo(() => Object.values(getUsersWithTasks()), [getUsersWithTasks]);
 const activeRequests = useMemo(() => getActiveAskHelpTasks(), [getActiveAskHelpTasks]);
 const answeredRequests = useMemo(() => getActiveAnsweredRequests(), [getActiveAnsweredRequests]);

 // Компонент колонки користувача
 const UserColumnComponent = useMemo(() => {
 return ({ user: userData }) => {
 const isUserCollapsed = collapsedUsers[userData.name];

 const getTasksByStatus = useCallback((tasks, statusKey) => {
 return tasks.filter(task => {
 const taskStatus = task.TaskStatus || task.taskStatus;
 return taskStatus === statusKey;
 });
 }, []);

 const toggleUserCollapse = useCallback((userName) => {
 setCollapsedUsers(prev => ({ ...prev, [userName]: !prev[userName] }));
 }, []);

 const toggleStatusCollapse = useCallback((statusKey) => {
 setCollapsedStatuses(prev => ({ ...prev, [statusKey]: !prev[statusKey] }));
 }, []);

 return (
 <div className={`user-column ${isUserCollapsed ? 'collapsed' : ''}`}>
 <div className="user-header" onClick={() => toggleUserCollapse(userData.name)}>
 <div className="user-name">
 <span className="role-icon">{userData.roleIcon}</span>
 {userData.name}
 </div>
 <button className="collapse-btn" onClick={(e) => { e.stopPropagation(); toggleUserCollapse(userData.name); }}>
 {isUserCollapsed ? '' : '▼'}
 </button>
 </div>

 {!isUserCollapsed && (
 <div className="user-statuses">
 {activeStatuses.map(status => {
 const statusTasks = getTasksByStatus(userData.tasks, status.key);
 if (statusTasks.length === 0) return null;

 const statusKey = `${userData.id}-${status.key}`;
 const isStatusCollapsed = collapsedStatuses[statusKey];

 return (
 <div key={status.key} className="status-section">
 <div className="status-header" onClick={() => toggleStatusCollapse(statusKey)}>
 <span className="status-name" data-status={status.key}>{status.label}</span>
 <span className="task-count">({statusTasks.length})</span>
 <span className="collapse-icon">{isStatusCollapsed ? '' : '▼'}</span>
 </div>

 {!isStatusCollapsed && (
 <div className="tasks-list">
 {statusTasks.map(task => {
 const taskName = task.TaskName || task.taskName || '';
 if (shouldExcludeTask(taskName)) return null;

 const timeData = taskTimers[task.TaskLink || task.taskLink] || calculateTimeInProgress(task.receivedAt);
 const mentor = getLatestMentor(task.TaskLink || task.taskLink);
 const hasMentorForTask = mentor && mentor.trim() !== '';
 const isKpiHiddenForTask = task.isKpiHidden;

 let statusText = '';
 if (hasMentorForTask) {
 statusText = ` Ментор: ${mentor}`;
 } else if (isKpiHiddenForTask) {
 statusText = ' Знята з KPI';
 }

 return (
 <div key={task.TaskLink || task.taskLink} className="task-item-wrapper">
 <div className="task-info-compact">
 <div className="task-name-small">{task.TaskName || task.taskName}</div>
 {timeData && <div className="task-time-small">{timeData.text}</div>}
 {statusText && <div className="task-status-small">{statusText}</div>}
 </div>
 <a href={task.TaskLink || task.taskLink} target="_blank" rel="noopener noreferrer" className="task-link-small">→</a>
 </div>
 );
 })}
 </div>
 )}
 </div>
 );
 })}
 </div>
 )}
 </div>
 );
 };
 }, [collapsedUsers, collapsedStatuses, activeStatuses, shouldExcludeTask, taskTimers, calculateTimeInProgress, getLatestMentor]);

 if (loading) {
 return <div className={`mentors-page ${theme === 'dark' ? 'dark-theme' : ''}`}><div className="loading">Завантаження...</div></div>;
 }

 if (error) {
 return <div className={`mentors-page ${theme === 'dark' ? 'dark-theme' : ''}`}><div className="error">{error}</div></div>;
 }

 return (
 <div className={`mentors-page ${theme === 'dark' ? 'dark-theme' : ''}`}>
 <div className="mentor-tasks-layout">
 <div className="columns-row">
 <TasksColumn
 title="Перша нагадуйка (15-54 хв)"
 visibleTasks={firstVisible}
 hiddenTasks={firstHidden}
 color="#ff9800"
 isCollapsed={collapsedFirstHidden}
 onToggleCollapse={() => setCollapsedFirstHidden(!collapsedFirstHidden)}
 taskTimers={taskTimers}
 />
 <TasksColumn
 title="Друга нагадуйка (45+ хв)"
 visibleTasks={secondVisible}
 hiddenTasks={secondHidden}
 color="#f44336"
 isCollapsed={collapsedSecondHidden}
 onToggleCollapse={() => setCollapsedSecondHidden(!collapsedSecondHidden)}
 taskTimers={taskTimers}
 />
 </div>

 <button className="show-all-tasks-btn" onClick={() => setShowAllTasks(!showAllTasks)}>
 {showAllTasks ? 'Приховати всі' : 'Показати всі'}
 </button>

 {showAllTasks && (
 <>
 <TasksColumn
 title="Менше 5 хвилин"
 visibleTasks={allTasksByTimeRanges.otherTasks}
 hiddenTasks={[]}
 color="#4caf50"
 isCollapsed={collapsedOtherTasks}
 onToggleCollapse={() => setCollapsedOtherTasks(!collapsedOtherTasks)}
 showHidden={false}
 isAllTasksColumn={true}
 taskTimers={taskTimers}
 />

 <div className="all-tasks-view">
 <h3>Всі задачі в роботі</h3>
 <div className="users-columns">
 {usersWithTasks.map(user => <UserColumnComponent key={user.id} user={user} />)}
 </div>
 </div>
 </>
 )}
 </div>

 <AnswerModal
 isOpen={modalState.isOpen}
 selectedTask={modalState.selectedTask}
 answerType={modalState.answerType}
 answerMinutes={modalState.answerMinutes}
 onAnswerTypeChange={handleAnswerTypeChange}
 onMinutesChange={handleMinutesChange}
 onSubmit={handleSubmitAnswer}
 onClose={closeModal}
 />
 </div>
 );
}

export default MentorsPage;